import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68fb60cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-us-content-block-wrap" }
const _hoisted_2 = { class: "contact-us-content-block" }
const _hoisted_3 = { class: "contact-us-content-block-text" }
const _hoisted_4 = { class: "contact-us-content-block-text second" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "contact-us-content-block-images" }
const _hoisted_8 = { href: "https://www.linkedin.com/company/runpay-solutions-ltd" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { href: "https://www.facebook.com/RunpaySolutions" }
const _hoisted_11 = ["src"]

import {Facebook_dark, Instagram_dark, Linkedin_dark, Telegram_dark, useLocalizationStore} from "@/shared";
import {GoogleMap} from "@/features";


export default /*#__PURE__*/_defineComponent({
  __name: 'contact-us-content-block',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("contact_us_content_first_text")), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("contact_us_content_second_text")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_unref(translate)('head_office')) + " ", 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_unref(translate)('address')) + ": " + _toDisplayString(_unref(translate)('address_riga')), 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_unref(translate)('email')) + ": info@hq.runpay.com ", 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _createElementVNode("img", {
                src: _unref(Linkedin_dark),
                alt: "Linkedin"
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("a", _hoisted_10, [
              _createElementVNode("img", {
                src: _unref(Facebook_dark),
                alt: "Facebook"
              }, null, 8, _hoisted_11)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(GoogleMap))
      ])
    ])
  ]))
}
}

})